import React, { FC } from 'react'
import ResultatsRecherche from '../resultats-recherche/ResultatsRecherche'
import MenuRecherche from '../../components/menu/MenuRecherche'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import styles from '../../styles'

const RechercheOffre: FC = () => {
	const { classes } = useStyles()
	return (
		<Grid container>
			<Grid container item className={classes.menuContainer}>
				<MenuRecherche standalone />
			</Grid>
			<ResultatsRecherche />
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	menuContainer: {
		zIndex: 2
	}
}))

export default RechercheOffre